import React from "react";
import PropTypes from "prop-types";
import {ListItemIcon} from "@mui/material";
import StyledTooltip from "../tooltips/StyledTooltip";
import {useSidebar} from "./Context/SidebarProvider";
import {useSidebarIconStyles} from "./sidebarStyles";
import {useFeatureFlags} from "../../context/FeatureFlagProvider";

const SidebarIcon = ({icon, text}) => {
  const {isSidebarHidden} = useSidebar();
  const {newSidebarDesign} = useFeatureFlags();
  const {classes} = useSidebarIconStyles({newSidebarDesign, isSidebarHidden});
  if (isSidebarHidden && !newSidebarDesign) {
    return (
      <StyledTooltip title={text} placement="right">
        <ListItemIcon className={classes.listItemIcon}>{icon}</ListItemIcon>
      </StyledTooltip>
    );
  }
  return (
    <ListItemIcon className={classes.listItemIcon}>
      {React.cloneElement(icon, {fontSize: "small"})}
    </ListItemIcon>
  );
};

SidebarIcon.propTypes = {
  icon: PropTypes.element.isRequired,
  text: PropTypes.string.isRequired,
};

export default SidebarIcon;
